'use strict'

/**
 * Name: #Day26 - Canvas Rainbow Animation
 * ===========================================
 */

export const RainbowAnimationOptions = {
  size: 20,
  speed: 0.02
}

export default class RainbowAnimation {
  /**
   * @constructor
   * @param {DomElement} el
   * @param {Object} options
   */
  constructor(el, options = {}) {
    this.frame = false
    this.animationFlag = false
    this.options = Object.assign({}, RainbowAnimationOptions, options)

    this.el = el
    this.canvas = document.createElement('canvas')
    this.canvas.width = this.options.size
    this.canvas.height = this.options.size
    this.el.appendChild(this.canvas)

    this.context = this.canvas.getContext('2d')
    this.t = 255
    this.w = this.canvas.width
    this.h = this.canvas.height

    this.init()
  }

  col(x, y, r, g, b) {
    this.context.fillStyle = `rgba(${r}, ${g}, ${b}, 0.8)`
    this.context.fillRect(x, y, 1, 1)
  }

  R(x, y, t) {
    return (Math.floor(
      192 +
      192 *
      Math.cos(
        (
          x * x -
          y * y
        ) /
        100 + t
      )
    ))
  }

  G(x, y, t) {
    return (Math.floor(
      192 +
      192 *
      Math.sin(
        (
          x * x * Math.cos(t / 4) +
          y * y * Math.sin(t / 3)
        ) /
        200
      )
    ))
  }

  B(x, y, t) {
    return (Math.floor(
      192 +
      192 *
      Math.sin(
        5 * Math.sin(t / 2) +
        (
          (x - 100) * (x - 100) +
          (y - 100) * (y - 100)
        ) /
        1100
      )
    ))
  }

  render() {
    for (let x = 0; x <= this.options.size; x++) {
      for (let y = 0; y <= this.options.size; y++) {
        this.col(x, y, this.R(x, y, this.t), this.G(x, y, this.t), this.B(x, y, this.t))
      }
    }
    this.t = this.t + this.options.speed
  }

  update() {
    this.context.clearRect(0, 0, this.w, this.h)
    this.render()
  }

  loop() {
    if (!this.animationFlag) {
      this.update()
      this.frame = window.requestAnimationFrame(this.loop.bind(this))
    }
  }

  destroy() {
    this.animationFlag = true
    if (this.frame) {
      window.cancelAnimationFrame(this.frame)
      this.frame = false
    }
  }

  init() {
    this.loop()
  }
}
